import { RpcTelemetryRecord } from './rpc-telemetry-model';

/**
 * Rpc telemetry sever side handler interface.
 */
export interface RpcTelemetryHandler {
    handler(data: RpcTelemetryRecord): Promise<void>;
}
